export default "__VITE_ASSET__C$UjKIhH__$_?nuxt_component=async&nuxt_component_name=SvgoPartner1688&nuxt_component_export=default__"